import $ from "cash-dom";

export const toggleBodyComponent = (root) => {
    console.log(root);
    $(root).find('.body-toggle-button').each((n, e) => {
        const $button = $(e);
        console.log(e);
        $button.on('click', () => {
            $button.parent().find('.body-toggle').toggleClass('body-toggle-on');
            $button.toggle();
        });
    })
};